'use strict'
import Vue from 'vue'
import Vuex from 'vuex'
import LoginStore from '../../common/login.store.js'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const dataState = createPersistedState({
  storage: window.localStorage,
  paths: ['login.token', 'login.finishStatus']
})

export default new Vuex.Store(
  {
    strict: process.env.NODE_ENV !== 'production', // [ext] open vuex strict mode
    modules: {
      login: LoginStore
    },
    plugins: [dataState]
  }
)



// WEBPACK FOOTER //
// ./src/common/provider/store.provider.js